import { LOCATION_CHANGE } from 'connected-react-router';

const historyChange = store => next => action => {
  let currentLocation, historyAction, nextLocation;
  if (action.type === LOCATION_CHANGE) {
    // must be gathered _before_ next or we can't get the old pathname
    currentLocation = store.getState()?.router?.location;
    historyAction = action?.payload?.action;
    nextLocation = action?.payload?.location;
  }
  const result = next(action);
  // any time we navigate to a new page, we must scroll to top to reset the scrolling
  // however if we POP (a.k.a. using the browser history buttons) we should preserve the scrolling that the browser
  // wants to do.
  // we only consider a pathname change as a page change
  // must happen _after_ next otherwise we may scroll before content gets replaced
  if (
    action.type === LOCATION_CHANGE &&
    historyAction === 'PUSH' &&
    currentLocation.pathname !== nextLocation.pathname
  ) {
    window.scrollTo(0, 0);
  }

  return result;
};

export default historyChange;
